import { type ReactNode } from 'react';

const PLACEMENT_CLASS = {
  top: 'bottom-full left-1/2 -translate-x-1/2 mb-1.5',
  bottom: 'top-full left-1/2 -translate-x-1/2 mt-1.5',
} as const;

type HoverTooltipProps = {
  label: ReactNode;
  children: ReactNode;
  placement?: keyof typeof PLACEMENT_CLASS;
  className?: string;
};

/** Visible on hover/focus — clearer than native `title` for icon-only controls. */
export function HoverTooltip({
  label,
  children,
  placement = 'top',
  className = '',
}: HoverTooltipProps) {
  return (
    <span className={`relative inline-flex group/tip ${className}`.trim()}>
      {children}
      <span
        role="tooltip"
        className={`pointer-events-none absolute ${PLACEMENT_CLASS[placement]} z-30 w-max max-w-[240px] px-2.5 py-1.5 text-[11px] leading-snug font-medium text-white bg-gray-900 dark:bg-gray-950 border border-gray-700 rounded-md shadow-lg opacity-0 scale-95 group-hover/tip:opacity-100 group-hover/tip:scale-100 group-focus-within/tip:opacity-100 group-focus-within/tip:scale-100 transition-all duration-150 text-center`}
      >
        {label}
      </span>
    </span>
  );
}
